(function($) {

	'use strict';

	var init = function() {
    
    var homeAnimation = document.getElementById('homeAnimation');
    var animItem = bodymovin.loadAnimation({
      wrapper: homeAnimation,
      animType: 'svg',
      autoplay: true,
      loop: false,
      path: 'wp-content/themes/billinglabs/animation/desktop.json'
    });
    
    //animItem.goToAndPlay(14200);

      /*animItem.addEventListener('DOMLoaded', function(e) {
        animItem.playSegments([450,477], true); // run intro animation
  });*/

  animItem.addEventListener('complete', function(e) {
    animItem.playSegments([352,477], true); // run loop animation
  });

  console.log('frames29');

  }

	$(document).ready(function() {
    if($('section').hasClass('homeHero')){
		  init();
    }
	});

})(jQuery);